import { useQuery } from "@apollo/client";
import { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  CustomInput,
  FormGroup,
} from "reactstrap";
import { GET_COMPARISON_DATA } from "../../../queries";
import EvaluationData from "./Module/EvaluationData";
import FinanceData from "./Module/FinanceData";

import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

import {
  useMyOrgInfo,
  useOrgPk,
  useOrgContract,
} from "../../../Layout/AppMain/LoginStatusContext";
import animetionLogo from "../../../assets/utils/images/animetion_logo.gif";
import { FaWindows } from "react-icons/fa";
import { sendGAEvent } from "../../../utils";

/**
 * 比較分析Page
 * @param {*} orgId: 団体ID
 * @returns
 */

const ComparisonDashboard = ({ orgId }) => {
  if ("このユーザーは団体と紐づいていません" == orgId) {
    window.location.href = "/#/dashboards/faq";
  }
  const orgPk = useOrgPk();
  const myOrgInfo = useMyOrgInfo();

  const myOrgId = myOrgInfo.id;
  const myOrgContractPlan =
    myOrgInfo.contract &&
    myOrgInfo.contract.plan &&
    myOrgInfo.contract.plan.name;

  useEffect(() => {
    if (myOrgId || loading) {
    } else {
      alert(
        "このページを利用するには「組織登録」が必要です。\n詳しくはFAQをご覧ください。"
      );
      window.location.href = "/#/dashboards/faq";
    }
  }, []);

  //モーダル state
  const [sizeModal, setSizeModal] = useState(false);

  //比較対象選択 state
  const [selectedData, setSelectedData] = useState(""); //比較するデータ（他団体or規模別）
  const [orgSelect, setOrgSelect] = useState();
  const [selectedAve, setSelectedAve] = useState({
    scale: "",
    avePk: "",
  });
  const [avePk, setAvePk] = useState(2);
  const [target, setTarget] = useState("");
  const [comparison, setComparison] = useState(); //比較する団体
  const [isFirst, setIsFirst] = useState(true);

  //団体Id state
  const [orgIdArray, setOrgIdArray] = useState([orgId]);

  const sizeModalToggle = () => setSizeModal(!sizeModal);

  const { loading, error, data, refetch } = useQuery(GET_COMPARISON_DATA, {
    variables: {
      orgPks: orgIdArray,
      orgPk2: orgPk,
      scaleAverageId: avePk,
    },
  });

  useEffect(() => {
    if (isFirst) {
      setIsFirst(!isFirst);
    } else {
      setOrgIdArray([Number(orgId), orgSelect[0].pk]);
    }
  }, [comparison]);

  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) {
    // alert("ログイン制限時間が切れました、再リロードしてください。");
    alert(error);
    window.location.href = "/#/dashboards/journy";
    window.location.reload();
  }
  if (!data) return "...Not Found";

  //団体データ
  const orgData = data.allOrgaccount.edges.map((array) => array.node);

  const selectOtherOrgHandle = () => {
    setTarget("他団体");
    setComparison(orgSelect);
    setSelectedAve("");
  };

  const selectIndustryHandle = () => {
    setTarget("業界平均");
    setSelectedAve("");
    setComparison();
  };

  const selectAveHandle = () => {
    setTarget("組織規模");
    setAvePk(selectedAve["avePk"]);
    setComparison();

    setSizeModal(!sizeModal);
  };

  return (
    <div className="ema__comparison_wrapper">
      <div className="mb-2 comp_area">
        <Button
          className="mr-2 pt-2 pb-2 pr-5 pl-5 main_button comp_btn"
          onClick={(e) => {
            sendGAEvent(
              "pageview",
              "/#/dashboards/comparison/market_average_tab"
            );
            if (myOrgContractPlan === "Free") {
              alert("現在のプランではご利用できません");
            } else {
              selectIndustryHandle();
            }
          }}
        >
          業界平均
        </Button>
        <Button
          className="mr-2 pt-2 pb-2 pr-5 pl-5 main_button comp_btn"
          onClick={() => {
            sendGAEvent("pageview", "/#/dashboards/comparison/cso_scale_tab");
            if (myOrgContractPlan === "Free") {
              alert("現在のプランではご利用できません");
            } else {
              sizeModalToggle();
            }
          }}
        >
          組織規模
        </Button>

        <Typeahead
          id="my-typeahead-id"
          options={orgData}
          placeholder="組織名"
          className="search_bar"
          onChange={setOrgSelect}
          selected={orgSelect}
          labelKey="name"
        />

        <Button
          onClick={() => {
            sendGAEvent("pageview", "/#/dashboards/comparison/cso_select_tab");
            if (myOrgContractPlan === "Free") {
              alert("現在のプランではご利用できません");
            } else {
              selectOtherOrgHandle();
            }
          }}
          className="mr-2 pt-2 pb-2 pr-5 pl-5 main_button"
        >
          組織セレクト
        </Button>
      </div>

      <div className="mb-2 scale__selected">
        {target == "組織規模" && (
          <div>
            {selectedAve.scale && (
              <Button className="mr-2 pt-2 pb-2 pr-5 pl-5 green_button">
                {selectedAve["scale"]}
              </Button>
            )}
          </div>
        )}
        {target == "業界平均" && (
          <div>
            <Button className="mr-2 pt-2 pb-2 pr-5 pl-5 green_button">
              業界平均
            </Button>
          </div>
        )}
        {comparison && (
          <Button className="mr-2 pt-2 pb-2 pr-5 pl-5 green_button">
            {comparison[0].name}
          </Button>
        )}
      </div>
      {/*** ↓ ↓ ↓ 財務データ ↓ ↓ ↓ ***/}
      <FinanceData
        orgIdArray={orgIdArray}
        orgPk={orgPk}
        avePk={avePk}
        target={target}
      />

      {/*** ↓ ↓ ↓ 組織診断結果 ↓ ↓ ↓ ***/}
      <EvaluationData
        orgIdArray={orgIdArray}
        orgPk={orgPk}
        avePk={avePk}
        target={target}
      />

      <Modal isOpen={sizeModal} toggle={sizeModalToggle}>
        <ModalBody className="mt-4 ml-3 mr-3 mb-3">
          <p className="bold">検索条件</p>
          <div className="sizeChoices">
            <CustomInput
              type="radio"
              id="1,000万円未満"
              name="規模"
              label="1,000万円未満"
              onChange={(e) => {
                setSelectedAve({ scale: e.target.id, avePk: 1 });
              }}
            />
            <CustomInput
              type="radio"
              id="1,000万-2,000万円未満"
              name="規模"
              label="1,000万-2,000万円未満"
              onChange={(e) => {
                setSelectedAve({ scale: e.target.id, avePk: 2 });
              }}
            />
            <CustomInput
              type="radio"
              id="2,000万-4,000万円未満"
              name="規模"
              label="2,000万-4,000万円未満"
              o
              onChange={(e) => {
                setSelectedAve({ scale: e.target.id, avePk: 3 });
              }}
            />
            <CustomInput
              type="radio"
              id="4,000万-6,000万円未満"
              name="規模"
              label="4,000万-6,000万円未満"
              onChange={(e) => {
                setSelectedAve({ scale: e.target.id, avePk: 4 });
              }}
            />
            <CustomInput
              type="radio"
              id="6,000万-8,000万円未満"
              name="規模"
              label="6,000万-8,000万円未満"
              onChange={(e) => {
                setSelectedAve({ scale: e.target.id, avePk: 5 });
              }}
            />
            <CustomInput
              type="radio"
              id="8,000万-1億円未満"
              name="規模"
              label="8,000万-1億円未満"
              onChange={(e) => {
                setSelectedAve({ scale: e.target.id, avePk: 6 });
              }}
            />
            <CustomInput
              type="radio"
              id="1億-3億円"
              name="規模"
              label="1億-3億円"
              onChange={(e) => {
                setSelectedAve({ scale: e.target.id, avePk: 7 });
              }}
            />
            <CustomInput
              type="radio"
              id="3億-5億円"
              name="規模"
              label="3億-5億円"
              onChange={(e) => {
                setSelectedAve({ scale: e.target.id, avePk: 8 });
              }}
            />
            <CustomInput
              type="radio"
              id="5億-10億円"
              name="規模"
              label="5億-10億円"
              onChange={(e) => {
                setSelectedAve({ scale: e.target.id, avePk: 9 });
              }}
            />
            <CustomInput
              type="radio"
              id="10億円以上"
              name="規模"
              label="10億円以上"
              onChange={(e) => {
                setSelectedAve({ scale: e.target.id, avePk: 10 });
              }}
            />
          </div>
          <div style={{ textAlign: "right" }}>
            <Button
              onClick={() => {
                selectAveHandle();
              }}
              className="pt-2 pb-2 pr-5 pl-5 main_button mt-3"
            >
              検索
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ComparisonDashboard;
